<template>
    <div>

        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <PageTitle v-bind:title="title" v-bind:admin="true" />


        <!-- Add Item form -->       
        <button type="button" class="btn btn-primary" @click.prevent="showAddForm">+ Новый ответ</button>
        <div class="modal fade" id="addForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Новый ответ</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <div class="form-group">
                            <label for="name" class="col-form-label">Название</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationAdd && errors.validationAdd.name">
                                {{ errors.validationAdd.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelAdding">Отмена</button>
                        <button type="button" class="btn btn-primary" @click.prevent="addRecord">Сохранить</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.add">
                        {{ errors.add }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Add Item form -->

        <!-- Модальное окно для подтверждения удаления -->
        <ModalOkCancel v-bind:data="ModalOkCancelData" v-on:mrok="deleteRecord2"/>

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <table class="table mt-4 bg-light shadow p-3 mb-5 rounded">
                <thead>
                    <tr>
                        <!--
                        <th></th>
                        -->
                        <th>Ответ</th>
                        <th>Правильный?</th>
                        <!--
                        <th></th>
                        <th></th>
                        -->
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data" :key="item.id">
                        <!--
                        <td>
                            {{ item.id }}
                        </td>
                        -->

                        <td>{{ item.name }}</td>
                        <td class="text-center">
                            <!-- {{ item.correct }} -->
                            <img v-if="item.correct" style="width: 32px;" src="/icons/correct.png" alt="">
                        </td>
                        <!--
                        <td>
                            <form @submit.prevent="deleteRecord(item.id)">
                                <button type="submit" class="btn btn-danger">Удалить</button>
                            </form>
                        </td>
                        <td>
                            <router-link :to="{ name: 'adminAnswer_edit', params: { id: item.id } }">Ред.ответ {{item.id}}</router-link>
                        </td>
                        -->
                        <td>
                            <ul class="nav nav-pills">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">&#9776;</a>
                                    <div class="dropdown-menu">
                                        <router-link class="alert alert-primary dropdown-item" :to="{ name: 'adminAnswer_edit', params: { id: item.id } }">Редактировать ответ</router-link>
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="alert alert-danger dropdown-item" @click.prevent="askToDeleteRecord(item)">УДАЛИТЬ</button>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import jQuery from 'jquery'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
import ModalOkCancel from '@/components/ModalOkCancel'

export default {
    data() {
        return {
            loading: true,
            data: [],
            id: 0,
            name: '',
            errors: {load: '', add: '', delete: '', edit: '', validationAdd: {}, validationEdit: {}},
            ModalOkCancelData: { id: 0, caption: '', message: '', show: false, style: '', okCaption: 'Удалить!' },
            title: 'Список ответов',
            bcrumbs: [],
        }
    },
   async mounted() {
       this.loadRecords(this.$route.params.question_id)
    },
    methods: {

        clearErrors() {
            this.errors.load = '';
            this.errors.add = '';
            this.errors.delete = '';
            this.errors.edit = '';
        },

        async loadRecords(question_id) {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/questions/'+question_id+'/answers')
                this.data = response.data.answers
                this.bcrumbs = response.data.bcrumbs
                //console.log(this.data);
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
        showAddForm() {
            this.name = ''
            this.errors.validationAdd = {}
            // this.errors.add = ''
            this.clearErrors();
            jQuery('#addForm').modal('show')
        },
        cancelAdding() {
            this.name = ''
            jQuery('#addForm').modal('hide')
        },
        //
        // Add new record.
        //
        async addRecord() {
            var question_id = this.$route.params.question_id
            this.errors.validationAdd = {}
            // this.errors.add = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/questions/'+question_id+'/answers', {name: this.name})
                if (response.status == 200) {
                    this.name = ''
                    this.loadRecords(question_id)
                    jQuery('#addForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationAdd = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.add = e.response.data.error
                }
                else {
                    this.errors.add = "Неизвестная ошибка при создании записи."
                }
            }
        },


        //
        // Показываем MessageBox с подтверждением удаления Ответа.
        //
        askToDeleteRecord(item) {
            this.clearErrors();
            this.ModalOkCancelData.id = item.id
            this.ModalOkCancelData.style = 'danger'
            this.ModalOkCancelData.caption = 'Внимание!'
            this.ModalOkCancelData.message = 'Вы действительно хотите удалить Ответ <strong>"' + item.name + '"</strong>?'
            this.ModalOkCancelData.show = true;
        },

        //
        // Удалить Ответ.
        //
        async deleteRecord2() {
            this.clearErrors();
            var id = arguments[0];
            if (id > 0) {
                try {
                    let response = await axios.delete('admin/answers/'+id)
                    if (response.status == 200) {
                        // удаление эл-та из списка "на клиенте":
                        let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                        this.data.splice(index, 1)            
                    }
                }
                catch (e) {
                    if (e.response.status == 520) {
                        this.errors.delete = e.response.data.error
                    }
                    else {
                        this.errors.delete = 'Неизвестная ошибка при удалении.'
                    }
                } 
            }
        },

        //
        // Delete record.
        //
        /*
        async deleteRecord(id) {
            this.errors.delete = ''
            try {
                let response = await axios.delete('admin/answers/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },
        */

    },
    components: {
        Loader,
        BreadCrumbs,
        PageTitle,
        ModalOkCancel,
    }
}
</script>